<ng-template #loader>
  <app-loader *ngIf="showLoader"></app-loader>
</ng-template>

<ng-container *ngIf="!showLoader else loader">
<div class="d-flex align-self-baseline mt-3" *ngIf="!!detail">

  <div class="card fitting-cards flex-fill">
    <div class="card-header text-center bg-dark bg-gradient text-white">
      <span class="fw-bold">O-Ring Details</span>
    </div>
    <div class="card-body">
      <div class="d-flex flex-column">
        <ng-container *ngTemplateOutlet="kv; context: {$implicit: 'Product/Part #', v:detail?.partNumber?.toUpperCase()}"></ng-container>
        <ng-container *ngTemplateOutlet="kv; context: {$implicit: 'Product Name', v:detail?.productName ?? 'UNKNOWN'}"></ng-container>
        <ng-container *ngTemplateOutlet="kv; context: {$implicit: 'SBU', v:detail?.sbu ?? 'UNKNOWN'}"></ng-container>
        <ng-container *ngTemplateOutlet="kv; context: {$implicit: 'SubSBU', v:detail?.subSBU ?? 'UNKNOWN'}"></ng-container>
        <ng-container *ngTemplateOutlet="kv; context: {$implicit: 'Product Family', v:detail?.productFamily ?? 'UNKNOWN'}"></ng-container>
        <ng-container *ngTemplateOutlet="kv; context: {$implicit: 'Sellable ID (WH)', v:detail?.sellableWH ?? 'UNKNOWN'}"></ng-container>
        <ng-container *ngTemplateOutlet="kv; context: {$implicit: 'Sellable ID (EH)', v:detail?.sellableEH ?? 'UNKNOWN'}"></ng-container>
        <!-- <ng-container *ngTemplateOutlet="kv; context: {$implicit: 'Lead Time', v:detail?.leadTime ?? 'UNKNOWN'}"></ng-container>
        <ng-container *ngTemplateOutlet="kv; context: {$implicit: 'Surge', v:detail?.surge ?? 'UNKNOWN'}"></ng-container>
        <ng-container *ngTemplateOutlet="kv; context: {$implicit: 'Purchase Price', v: (detail?.purchasePrice | currency) ?? 'UNKNOWN'}"></ng-container> -->
        <hr />
        <ng-container *ngTemplateOutlet="kv; context: {$implicit: 'Pipe Sizes', v: detail?.sizeList ?? 'UNKNOWN'}"></ng-container>
        <ng-container *ngTemplateOutlet="kv; context: {$implicit: 'Material', v: detail?.materialName ?? 'UNKNOWN'}"></ng-container>
        <ng-container *ngTemplateOutlet="kv; context: {$implicit: 'Durometer', v: detail?.durometer ?? 'UNKNOWN'}"></ng-container>
        <ng-container *ngTemplateOutlet="kv; context: {$implicit: 'Temp. Range', v: (detail | oringTempRange) ?? 'UNKNOWN'}"></ng-container>

        <div class="card mt-4">
          <div class="card-header text-center"><b>Compatible Closures</b></div>
          <div class="card-body" style="display: grid; grid-template-columns: 1fr 1fr 1fr;">
            <button 
                *ngFor="let closure of detail?.closureList?.split(',')"
                class="text-tdw border-0 bg-transparent text-decoration-underline"
                (click)="viewClosureModal(closure)">
              <b>{{closure}}</b>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #kv let-k let-v="v">
  <div class="d-flex flex-wrap">
    <span class="fw-bold me-auto">{{k}}:</span>
    <span class="ms-3">{{v}}</span>
  </div>
</ng-template>

</ng-container>
